export default __webpack_public_path__ + "content/media/36.8c50dd99.jpg";